import {
  GET_EQUIPMENT_REQUEST,
  GET_EQUIPMENT_ERROR,
  GET_EQUIPMENT_SUCCESS,
  CREATE_EQUIPMENT_REQUEST,
  CREATE_EQUIPMENT_ERROR,
  CREATE_EQUIPMENT_SUCCESS,
  UPDATE_EQUIPMENT_REQUEST,
  UPDATE_EQUIPMENT_ERROR,
  UPDATE_EQUIPMENT_SUCCESS,
  DELETE_EQUIPMENT_REQUEST,
  DELETE_EQUIPMENT_ERROR,
  DELETE_EQUIPMENT_SUCCESS,
} from "../../actions/types";
import reducers from "../common"

const initialState = {};
export default (state = initialState, action) => {

  reducers.init(reducers);

  reducers.GET_ENTITY_REQUEST = GET_EQUIPMENT_REQUEST;
  reducers.GET_ENTITY_ERROR = GET_EQUIPMENT_ERROR;
  reducers.GET_ENTITY_SUCCESS = GET_EQUIPMENT_SUCCESS;
  reducers.CREATE_ENTITY_REQUEST = CREATE_EQUIPMENT_REQUEST;
  reducers.CREATE_ENTITY_ERROR = CREATE_EQUIPMENT_ERROR;
  reducers.CREATE_ENTITY_SUCCESS = CREATE_EQUIPMENT_SUCCESS;
  reducers.UPDATE_ENTITY_REQUEST = UPDATE_EQUIPMENT_REQUEST;
  reducers.UPDATE_ENTITY_ERROR = UPDATE_EQUIPMENT_ERROR;
  reducers.UPDATE_ENTITY_SUCCESS = UPDATE_EQUIPMENT_SUCCESS;
  reducers.DELETE_ENTITY_REQUEST = DELETE_EQUIPMENT_REQUEST;
  reducers.DELETE_ENTITY_ERROR = DELETE_EQUIPMENT_ERROR;
  reducers.DELETE_ENTITY_SUCCESS = DELETE_EQUIPMENT_SUCCESS;
  reducers.entityName = "equipment";

  return reducers.entity(reducers)(state, action);
};